import { FC } from 'react';

import Hyperlink from '@ingka/hyperlink';
import {
  AccountVoucherDetails,
  InstallmentComponent,
  PaymentDetailsContainer,
  t,
} from '@onlinepayments/payments-library';

import DeliveryInfo from '../../components/DeliveryInfo';
import { Divider } from '../../components/toolkit';
import IOrderDetails from '../../interfaces/OrderDetails';
import { getCountryCode, getLanguageCode } from '../../utils/localization';

const getTrackOrderUrl = (orderNumber: string) =>
  `${window.location.origin}/${getCountryCode()}/${getLanguageCode()}/purchases/${orderNumber}/`;

interface IOrderDetailsProps {
  details: IOrderDetails;
  hideOpeningHours: boolean;
}

const OrderDetails: FC<IOrderDetailsProps> = ({ details, hideOpeningHours }) => {
  const { orderNumber, billingContact, shippingContact, deliveryServices } = details;

  return (
    <>
      <div className="text-center">
        <InstallmentComponent />

        <div className="mb-150">
          {t('order.customer_order_number_text')}
          <strong> {orderNumber}</strong>
        </div>

        <Hyperlink
          className="mb-150 display-block"
          text={t('order.track_order_link_text')}
          newWindow
          url={getTrackOrderUrl(orderNumber)}
        />

        <div className="mb-200">
          {t('order.order_confirmation_email_info')}
          <strong> {billingContact.email}</strong>.
        </div>
      </div>

      <Divider />

      <div className="divider-if-content">
        <AccountVoucherDetails />
        <Divider />
      </div>
      <div className="divider-if-content">
        <PaymentDetailsContainer />
        <Divider />
      </div>

      {!!deliveryServices && (
        <>
          <div className="mb-100">{t('delivery_info_header')}</div>
          <DeliveryInfo
            shippingContact={shippingContact}
            deliveryServices={deliveryServices}
            showOpeningHours={!hideOpeningHours}
          />
        </>
      )}
    </>
  );
};

export default OrderDetails;
